"use client";

import { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";
import { useTranslations } from "next-intl";

const ICON_SIZE = "w-5 h-5";

function ThemeToggle() {
  const [dark, setDark] = useState(false);
  const t = useTranslations('General');

  useEffect(() => {
    const isDark =
      localStorage.getItem("theme") === "dark" ||
      (!localStorage.getItem("theme") &&
        window.matchMedia("(prefers-color-scheme: dark)").matches);

    setDark(isDark);
    document.documentElement.classList.toggle("dark", isDark);
  }, []);

  const toggleTheme = () => {
    const newDark = !dark;
    setDark(newDark);
    localStorage.setItem("theme", newDark ? "dark" : "light");
    document.documentElement.classList.toggle("dark", newDark);
  };

  // Set accessible name based on current theme
  const ariaLabel = dark ? t('switchToLightMode') : t('switchToDarkMode');

  return (
    <button 
      onClick={toggleTheme} 
      className="cursor-pointer"
      aria-label={ariaLabel}
      title={ariaLabel}
    >
      {dark ? <Sun className={ICON_SIZE} /> : <Moon className={ICON_SIZE} />}
    </button>
  );
}

export default ThemeToggle;